<template>
  <transition name="modal">
      <modal :close="close" v-show="modalOpen" class="modal-wide">
        <h3 slot="header">{{ $t("profile.kyc.informationsMissing") }}</h3>
        <div slot="body">
          <form v-if="!user.mangopay_id" @submit.prevent="updateUser()" id="lightKycForm">
            <h5>{{ $t("profile.kyc.addMissingInformations") }}</h5>
            <div>
              <h5 class="mb-20 mt-30">
                <strong>
                  {{ `${user.full_name} (${user.email})` }}
                </strong>
              </h5>
              <datepicker v-model="user.birthday"
                format="yyyy-MM-dd"
                :typeable="false"
                :language="datapickerLang"
                class="mb-20"
                input-class="form-control"
                :placeholder="$t('profile.edit.birthday')">
              </datepicker>
              <select v-if="countries.length" v-model="user.country_id" class="form-control mb-20">
                <option disabled value="null">{{ $t('country') }}</option>
                <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
              </select>
              <select v-if="countries.length" v-model="user.country_of_residence_id" class="form-control mb-20">
                <option disabled value="null">{{ $t('countryOfResidence') }}</option>
                <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
              </select>
            </div>
            <alert :error="alert.error" :success="alert.success"></alert>
          </form>
          <user-kyc v-if="user.mangopay_id" :documentId="user.kyc_document_id"/>
        </div>
        <button type="submit"
          slot="footer"
          form="lightKycForm"
          class="btn btn-primary"
          style="width: 100px; margin: 5px"
          :disabled="!isValid">
          <span v-if="!processing">{{ $t("save") }}</span>
          <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
        </button>
      </modal>
  </transition>
</template>

<script>
import userApi from '@/api/v1/user';
import dictionariesApi from '@/api/v1/shared/dictionaries';
import Modal from '@/components/Modal';
import Alert from '@/components/Alert';
import UserKyc from '@/components/Profile/Kyc';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import Datepicker from 'vuejs-datepicker';
import { pl, en } from 'vuejs-datepicker/src/locale';
// Mixins
import alert from '@/mixins/alert';

export default {
  mixins: [alert],
  components: { Modal, ClipLoader, Datepicker, Alert, UserKyc },
  data() {
    return {
      user: {},
      countries: [],
      modalOpen: false,
      processing: false,
    };
  },
  computed: {
    datapickerLang() {
      return localStorage.getItem('lang') === 'en' ? en : pl;
    },
    isValid() {
      return this.user.birthday && this.user.country_id && this.user.country_of_residence_id;
    },
  },
  methods: {
    close() {
      this.modalOpen = false;
    },
    open() {
      this.modalOpen = true;
    },
    updateUser() {
      this.processing = true;
      this.clearAlerts();
      userApi
        .updateUser(this.user)
        .then(() => {
          this.processing = false;

          this.alert.success = this.$t('profile.edit.updateSuccess');
          this.close();
        })
        .catch((response) => {
          this.processing = false;

          this.errors = response.response.data;
          this.alert.error = this.$t('profile.incorrectData');
        });
    },
  },
  created() {
    userApi.myProfile((user) => {
      this.user = user;
      this.$emit('fetch:user', user);
    });
    dictionariesApi.getCountries((countries) => {
      this.countries = countries;
    });
  },
};
</script>



// WEBPACK FOOTER //
// LightKYC.vue?5bb82e03